export const EMA100_CSTICS = {
  seriesHero: "EMA100_SERIES_HERO",
  actuatorSeries: "VMKB_105",
  actuatorType: "VSPA_105",
  screwDiameterAndLead: "VSPT_105",
  standardStroke: "VKWLS_105",
  customStroke: "VKWL_105",
  screwType: "VSCR_105",
  strokeOrientation: "VROC_105",
  frontMounting: "VGVO_105",
  frontParallel: "VOFP_105",
  frontFlange: "VOFF_105",
  frontPivot: "VFPI_105",
  housingOrientation: "VAOH_105",
  rearMounting: "VBHIS_105",
  rearParallel: "VORP_105",
  rearFlange: "VORF_105",
  rearPivot: "VRPI_105",
  support: "VSUA_105",
  visualInspection: "VVSI_105",
  bellows: "VBLT_105",
  sensorOption: "VNSO_105",
  endOption: "VEND_105",
  lubrication: "VSCHA_105",
  limitSwitch: "VLSW_105",
} as const;
